@if (overlayService.isLoading()) {
  <lbt-loader
    size="xxlg"
    overlayColor="dark"
    overlayLabel="WORKING ..."
  />
}
<!-- cdkScrollable registers this (position:fixed; overflow:auto) scroll container
     with CDK's ScrollDispatcher so overlay-based dropdowns (mat-autocomplete for
     Facility Name / City, mat-select) reposition or close on scroll instead of
     detaching and floating over the page on mobile (LBRD-5834). The desktop
     scroll container is already registered the same way. -->
<div class="mobile-layout" cdkScrollable>
  <lbt-mobile-header class="header"></lbt-mobile-header>
  <div class="mobile-content">
    <router-outlet></router-outlet>
  </div>
</div>

<ng-template #sessionExpiredTmpl>
  <lbt-confirmation
    okText='Sign back in'
    okType='primary'
    title="Your session has expired"
    [hideCancelBtn]='true'
    [showHeader]="true"
    [confirmContent]='sessionExpiredTextTmpl'>
  </lbt-confirmation>
</ng-template>

<ng-template #sessionExpiredTextTmpl>
  <lbt-text typography="body1" color="gray-12">
    For your security, we log you out automatically when you have not been active for a certain period of time.
  </lbt-text>
</ng-template>
